import { IconFont } from '@byecode/ui/components/IconFont'
import { Menu } from '@byecode/ui/components/Menu'
import { useCurrentEditor } from '@tiptap/react'
import type { FC } from 'react'
import React from 'react'

import { isMobileDevice } from '../../../utils/getApplicationPreviewType'
import { DropdownActionButton } from './styles'

const OPTIONS = [
    '9px',
    '10px',
    '11px',
    '12px',
    '14px',
    '16px',
    '18px',
    '20px',
    '22px',
    '24px',
    '26px',
    '28px',
    '36px',
    '42px',
    '48px',
    '72px'
]

export const FontSizeMenu: FC = () => {
    const { editor } = useCurrentEditor()

    const currentSize = editor?.getAttributes('textStyle').fontSize

    return (
        <Menu withinPortal zIndex={300} width={120} trigger={isMobileDevice() ? 'click' : 'hover'} position="bottom">
            <Menu.Target>
                <DropdownActionButton>
                    <span style={{ fontSize: 12 }}>{currentSize || `16px`}</span>
                    <IconFont size={10} type="ArrowDownSmallGray" color="var(--color-gray-500)" />
                </DropdownActionButton>
            </Menu.Target>
            <Menu.Dropdown>
                {OPTIONS.map(item => (
                    <Menu.Item
                        key={item}
                        style={currentSize === `${item}` ? { backgroundColor: 'var(--color-gray-100)' } : {}}
                        onClick={() =>
                            editor?.isActive('textStyle', { fontSize: item })
                                ? editor.chain().focus().unsetFontSize().run()
                                : editor?.chain().focus().setFontSize(item).run()
                        }
                    >
                        {item}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
